__turbopack_context__.v({
  "button": "Pickup-module-scss-module__C_buzq__button",
  "header": "Pickup-module-scss-module__C_buzq__header",
  "map": "Pickup-module-scss-module__C_buzq__map",
  "mapBody": "Pickup-module-scss-module__C_buzq__mapBody",
  "tabs": "Pickup-module-scss-module__C_buzq__tabs",
});
